import { render, staticRenderFns } from "./RatesAction.vue?vue&type=template&id=c3c1ef54"
import script from "./RatesAction.vue?vue&type=script&lang=js"
export * from "./RatesAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports